import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { commonActions } from '../../actions';
import { Button } from 'semantic-ui-react';
import SvgIcon from './svg-icon/svg-icon';

const Message = ({ auth, userId, userName, showLoginModalnew }) => {

    const check_login = () => {
        showLoginModalnew(true)
    }

    return (
        <span>
            {
                auth ?
                    <Link to={`/message?userId=${userId}&userName=${userName}`} title="Message" className="user-profile-messageicon text-primary">
                        <Button className='send-msg-btn'>
                            <SvgIcon name='mail-icon' viewbox="0 0 22 18" />
                            Send message
                        </Button>
                    </Link>
                    :
                    <span className="color-green cursor-pointer font-21" onClick={check_login}>Send message </span>
            }
        </span>
    )
}

const mapDispatchToProps = dispatch => {
    return {
        ...bindActionCreators({ ...commonActions }, dispatch)
    }
}

export default connect(null, mapDispatchToProps)(Message);